import { CircularProgress, Stack } from "@mui/material";
import React from "react";

function LoadingSpinner() {

  return (
    <Stack spacing={2} direction="row">
      <CircularProgress color="darkPinkPrimary" size={60} disableShrink />
      <CircularProgress color="greenPrimary" size={60} disableShrink />
      <CircularProgress color="darkBluePrimary" size={60} disableShrink />
    </Stack>
  );
}

export default LoadingSpinner;
